var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"mainCol mx-auto",staticStyle:{"max-width":"1400px"},attrs:{"cols":"12","sm":"11","md":"10","lg":"9"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }